import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { Slider } from 'react-semantic-ui-range';

import { v4 } from 'uuid';
import { TextAreaFormField, InputFormField } from '@playbookux/playbook-web-core';

import {
  Container,
  ContainerTitle,
  IconTitle,
  Title,
  Radio,
  RadioGroup,
  RatingValue,
  Row,
  ContainerRadio,
  ContainerSlider,
  Number,
  ContainerInput,
  QuestionIndex,
} from './styles';

import ErrorMessage from '../error';

const Range = (props) => {
  const {
    question,
    index,
    errors,
    touched,
    setFieldValue,
    isEdit,
    taskIndex,
    testType,
  } = props;

  let range = '';
  let label = '';
  let leftName = '';
  let rightName = '';

  if (testType === 'survey') {
    range = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}].` : ''}tasks.${index}.range`;
    label = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}].` : ''}tasks.${index}.label`;
    leftName = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}].` : ''}tasks.${index}.leftLabel`;
    rightName = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}].` : ''}tasks.${index}.rightLabel`;
  } else {
    range = `${(taskIndex || taskIndex === 0) ? `tasks[${taskIndex}].` : ''}tasks.${index}.range`;
    label = `${(taskIndex || taskIndex === 0) ? `tasks[${taskIndex}].` : ''}tasks.${index}.label`;
    leftName = `${(taskIndex || taskIndex === 0) ? `tasks[${taskIndex}].` : ''}tasks.${index}.leftLabel`;
    rightName = `${(taskIndex || taskIndex === 0) ? `tasks[${taskIndex}].` : ''}tasks.${index}.rightLabel`;
  }

  const remapQuestionsOptions = (task) => {
    const questionOptions = [];
    if (task.questionType === 'range') {
      if ((task.questionOptions && task.range >= task.questionOptions.length) || !task.questionOptions) {
        for (let i = 0; i < task.range; i += 1) {
          let option = { label: (i + 1).toString(10) };

          option = {
            label: task.questionOptions[i]?.label || option.label,
            order: task.questionOptions[i]?.label || option.label,
            id: task.questionOptions[i]?.id || v4(),
            disqualify: null,
            qualify: false,
          };

          questionOptions.push(option);
        }
      }
    }

    // eslint-disable-next-line no-param-reassign
    task.questionOptions = questionOptions;
  };

  const settings = {
    start: 5,
    min: 5,
    max: 10,
    step: 1,
    onChange: (value) => {
      setFieldValue(range, value);
    },
  };

  useEffect(() => {
    if (testType === 'survey') {
      remapQuestionsOptions(question);
    }
  }, [question]);

  return (
    <Container>
      <ContainerTitle>
        <QuestionIndex>{index + 1}</QuestionIndex>
        <IconTitle src="/images/question-rate.png" />
        <Title color="questionTitleRange">
          Rating Scale
        </Title>

        <ContainerSlider>
          <Slider
            value={question.range}
            disabled={isEdit}
            settings={settings}
            style={{ trackFill: { backgroundColor: '#FFCD6E' } }}
          />
        </ContainerSlider>

        <RatingValue>{question.range}</RatingValue>

      </ContainerTitle>
      <Field
        placeholder="Start typing your question"
        minWidth="100%"
        component={TextAreaFormField}
        name={label}
      />
      <ErrorMessage
        index={index}
        errors={errors}
        touched={touched}
      />
      <ContainerRadio>
        <Row>
          <RadioGroup>
            {[...Array(question.range)].map(() => (
              <Radio readOnly />
            ))}
          </RadioGroup>
          <RadioGroup>
            {[...Array(question.range)].map((e, i) => (
              <Number>{i + 1}</Number>
            ))}
          </RadioGroup>
        </Row>
      </ContainerRadio>
      <ContainerInput>
        <Field
          component={InputFormField}
          name={leftName}
          placeholder="Label i.e. Very Difficult"
        />

        <Field
          component={InputFormField}
          name={rightName}
          placeholder="Label i.e. Very Easy"
        />
      </ContainerInput>
    </Container>
  );
};

Range.propTypes = {
  question: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  taskIndex: PropTypes.number,
  testType: PropTypes.string.isRequired,
};

Range.defaultProps = {
  isEdit: false,
  taskIndex: null,
};

export default Range;
